const twitterLogo = "/static/images/twitter.svg";
const facebookLogo = "/static/images/facebook.svg";
const linkedInLogo = "/static/images/in.svg";

const caretDown = "/static/images/white_caret_down.png";
const greyCaretDown = "/static/images/grey_caret_down.png";

export const images = {
  twitterLogo,
  facebookLogo,
  linkedInLogo,
  caretDown,
  greyCaretDown
};
